import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
    selectAllTextTemplateTag,
    selectTextTemplateTagEntities, selectTextTemplateTagFetched, selectTextTemplateTagLatestUpdatedAt,
    TEXT_TEMPLATE_TAG_KEY,
    TextTemplateTagState,
} from '../reducers/text-template-tag.reducer';





const selectState = createFeatureSelector<TextTemplateTagState>(TEXT_TEMPLATE_TAG_KEY);

export const getTextTemplateTagDictionary = createSelector(selectState, selectTextTemplateTagEntities);
export const getTextTemplateTag = createSelector(selectState, selectAllTextTemplateTag);
export const getTextTemplateTagFetched = createSelector(selectState, selectTextTemplateTagFetched);
export const getTextTemplateTagLatestUpdatedAt = createSelector(selectState, selectTextTemplateTagLatestUpdatedAt);

export const getTextTemplateTagById = (props: { id: number }) => createSelector(getTextTemplateTagDictionary, (dictionary) => props?.id && dictionary[props.id]);

export const getTextTemplateTagsByIds = (props: { ids: number[] }) =>
    createSelector(
        getTextTemplateTagDictionary,
        (dictionary) =>
            props?.ids?.map((id) => dictionary[id]).filter(Boolean) ?? []
    );
